import styled from 'styled-components';

import { StyledLink } from './StyledLink';

export const UserNameLink = styled(StyledLink)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
